import React, { useEffect } from "react";
import BIDButton from "../../components/reusable/BIDButton/BIDButton";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import TEXT from "../../utils/text/abcProtocol.json";
import "./ABCProtocol.css";

export default function ABCProtocol() {
  const { language } = useCurrentLanguage();

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  return (
    <div className="pnud-section-container">
      <div className="pnud-section-title">
        <h1 className="abc-title">{TEXT["title"][language]}</h1>

        <div className="abc-content">
            <div className="abc-info">
                <div className="pnud-section-description">
                    <h4 className="abc-subtitle">{TEXT["about"]["title"][language]}</h4>
                    {TEXT["about"]["description"][language].map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}
                </div>
                <div className="pnud-section-description">
                    <h4 className="abc-subtitle">{TEXT["objective"]["title"][language]}</h4>
                    <p>{TEXT["objective"]["description"][language]}</p>
                </div>

                <div
                    className="pnud-section-report-button"
                    style={{ marginBottom: "10px" }}
                >
                    <a
                        href="https://publications.iadb.org/es/un-mundo-mejor-para-la-poblacion-migrante-en-america-latina-y-el-caribe"
                        target={"_blank"}
                        rel="noreferrer"
                    >
                        <BIDButton
                        text={TEXT["buttons"]["protocol"][language]}
                        type={"light"}
                        size={"medium"}
                        />
                    </a>
                </div>
                <div className="pnud-section-report-button">
                    <a href="/AnexoEnLínea.zip" download>
                        <BIDButton
                            text={TEXT["buttons"]["protocol_route"][language]}
                            type={"dark"}
                            size={"medium"}
                        />
                    </a>
                </div>
            </div>
            <div>
                <div className="abc-section-image-container ">
                    <img
                        alt="Page Header"
                        src={require("../../images/dashboard/abc_protocol/abc_protocol_banner.png")}
                        className="abc-section-image"
                    />
                </div>
                <div className="abc-section-image-container ">
                    <img
                        alt="Page Header"
                        src={require("../../images/dashboard/abc_protocol/xenoo.png")}
                        className="abc-section-image"
                    />
                </div>
            </div>
        </div>
        
        <div>
            <h4 className="abc-subtitle">{TEXT["institutions"]["title"][language]}</h4>
            <div className="">
                <img
                    alt="Page Header"
                    src={require("../../images/dashboard/abc_protocol/logos.png")}
                    className="abc-section-image"
                />
            </div>
        </div>
      </div>
    </div>
  );
}